import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { formatToString } from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { CURRENCIES } from 'constants/app-config'

export const ExchangeRate = ({ exchange_rate = null }) => {
  if (!exchange_rate) {
    return null
  }
  const { t } = useTranslation(['billing'])
  const { value = null, from, to } = exchange_rate

  if (value === null || from === to || value === 1) {
    return null
  }

  return (
    <div className={styles['billing__calculated-data-item']}>
      {t('exchange_rate', {
        amount: formatToString(value, from, 4),
        currency: formatToString(1, to).replace('.00', ''),
      })}
    </div>
  )
}

ExchangeRate.propTypes = {
  exchange_rate: PropTypes.shape({
    value: PropTypes.number,
    to: PropTypes.oneOf(CURRENCIES),
    from: PropTypes.oneOf(CURRENCIES),
  }),
}
